// Diárias da locação: multiplicam o valor de cada item no orçamento e no contrato.
// O backend aplica a mesma regra (Talkvia::Contracts::RentalDays).
export const MAX_RENTAL_DAYS = 365;

export const normalizeRentalDays = value => {
  const days = Number.parseInt(String(value ?? '').replace(/\D/g, ''), 10);
  if (!Number.isFinite(days) || days < 1) return 1;
  return Math.min(days, MAX_RENTAL_DAYS);
};

const dateKey = value => String(value || '').slice(0, 10);

// Sugestão pelas datas: diferença em dias corridos entre retirada e entrega (mínimo 1).
export const suggestRentalDays = (scheduledAt, pickupAt) => {
  const start = dateKey(scheduledAt);
  const end = dateKey(pickupAt);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(start) || !/^\d{4}-\d{2}-\d{2}$/.test(end)) {
    return null;
  }
  const difference = Math.round(
    (Date.parse(`${end}T00:00:00Z`) - Date.parse(`${start}T00:00:00Z`)) /
      86400000
  );
  return difference >= 1 ? Math.min(difference, MAX_RENTAL_DAYS) : 1;
};

export const rentalItemTotal = (quantity, unitPrice, days) =>
  Number(quantity || 0) * Number(unitPrice || 0) * normalizeRentalDays(days);

// Item com valor fechado (ex.: frete) não multiplica pelas diárias: `skip_rental_days` no
// payload/metadata (o backend usa Talkvia::Contracts::RentalDays.skip?).
export const skipsRentalDays = item =>
  item?.skip_rental_days === true ||
  item?.skip_rental_days === 'true' ||
  item?.skipRentalDays === true;

export const itemRentalDays = (item, days) =>
  skipsRentalDays(item) ? 1 : normalizeRentalDays(days);
